/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BlockIcon64Regular = forwardRef('BlockIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 6C17.64 6 6 17.64 6 32s11.64 26 26 26 26-11.64 26-26S46.36 6 32 6Zm-15.168 8.71A22.912 22.912 0 0 1 32 9c12.703 0 23 10.297 23 23 0 5.811-2.155 11.12-5.71 15.168L16.832 14.71Zm-2.122 2.121A22.912 22.912 0 0 0 9 32c0 12.703 10.297 23 23 23 5.812 0 11.12-2.155 15.169-5.71L14.71 16.83Z" })));
});
